<template>
  <div class="medical-records-tab medical-records-tab--anamnesis">
    <p class="text-muted mb-0">{{ $t("prontuariosPage.tabs.anamnesis.placeholder") }}</p>
  </div>
</template>

<script>
export default {
  name: "MedicalRecordsAnamnesisTab",
  props: {
    entityType: {
      type: String,
      default: "",
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    patient: {
      type: Object,
      default: null,
    },
  },
};
</script>
